import * as React from 'react';
import PropTypes from 'prop-types';
var SvgActionsKudoHighlightedXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("style", null), /*#__PURE__*/React.createElement("g", {
    id: "actions_kudo_highlighted_xsmall_svg__Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.263 8.251l-2.122.816a1 1 0 00-.567 1.311l1.833 4.5a1 1 0 001.305.548l2.121-.868-2.57-6.307zM14.786 6.799a1.26 1.26 0 00-.294-.8 1.457 1.457 0 00-.718-.443 2.25 2.25 0 00-.39-.056H9.021c.232-.778.572-2.035.572-2.734 0-1.521-1.409-2.191-1.469-2.219a.497.497 0 00-.705.385L7.122 3.1 4.624 7.731l-.013.002-.415.16 2.561 6.287.44-.18H11.9a.493.493 0 00.215-.055 1.494 1.494 0 001.164-1.268l.242-1.696a.75.75 0 01.24-.451c.398-.359.609-.815.609-1.319 0-.299-.143-.549-.144-.552a.751.751 0 01.169-.99c.163-.128.391-.522.391-.87z"
  })));
});
SvgActionsKudoHighlightedXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgActionsKudoHighlightedXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgActionsKudoHighlightedXsmall;